import {QUOTATION_DETAILS} from "../../constant/ActionType";

export default function quotationssDetailReducer(state = {
    quotationdetail:[],
    statusCode: null,
}, action) {
    switch (action.type) {    
        case QUOTATION_DETAILS:
			return { ...state,
				quotationdetail: action.data ,
                statusCode:action.status
            };

        default:
    }
    return state;
}
